import firebase from 'firebase/app'
import Rebase from 're-base'
import 'firebase/database'
import 'firebase/auth'

// Initialize Firebase
const config = {
	apiKey: "AIzaSyC9Uxmu8Bu0OpRaH0f4a7nHPJW0UeLajWo",
	authDomain: "chat-xtern.firebaseapp.com",
	databaseURL: "https://chat-xtern.firebaseio.com",
	projectId: "chat-xtern",
	storageBucket: "chat-xtern.appspot.com",
	messagingSenderId: "644364458103",
}

const app = firebase.initializeApp(config)

// Configure authentication
export const auth = firebase.auth()
export const googleProvider = new firebase.auth.GoogleAuthProvider()
export const githubProvider = new firebase.auth.GithubAuthProvider()

// Configure database
const db = firebase.database(app)

export default Rebase.createClass(db)


// WEBPACK FOOTER //
// ./src/base.js